import { NgModule } from '@angular/core';
import { PageMetaResolver } from '@spartacus/core';
import { CategoryPageMetaResolver } from './category-page-meta.resolver';
import { PromoCampaignPageMetaResolver } from './promo-campaign-page-meta.resolver';
import { PromoContentPageMetaResolver } from './promo-content-page-meta.resolver';
import { CustomSearchPageMetaResolver } from './search-page-meta.resolver';
import { TagPageMetaResolver } from './tag-page-meta.resolver';

@NgModule({
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: CategoryPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: CustomSearchPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: PromoCampaignPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: PromoContentPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: TagPageMetaResolver,
      multi: true,
    },
  ],
})
export class CatalogResolversModule {}
